import { helpers } from './../../../core/utils/helpers';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { IFilter, IPagingResponse } from '../../../core/interfaces';

@Injectable({
  providedIn: 'root'
})
export class FilterApiService {
  #http = inject(HttpClient)
  /**
   * @param  {string} url
   * @param  {IFilter} params
   * @returns Observable
   */
  getFilteredData(url: string, params: IFilter): Observable<IPagingResponse<any>> {
    return this.#http.get<IPagingResponse<any>>(`${url}`, { params: helpers.setUrlQueryParams(helpers.removeNullUndefined(params)) })
  }
}
